import React, { useCallback } from "react";
import { useAccount } from "../../../Account";
import { Box } from "@mui/material";
import { useNavigate, useParams, Outlet } from "react-router-dom";
import AccountGuardianSelector from "../AccountGuardianSelector";
import { useScrollToTop } from "@tlc/ui/ScrollToTop";

export const AccountFinesPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const { hasChildrenAndCanViewDependentFinesActivity } = useAccount();
  const [scrollCallbackRef, scrollToTop] = useScrollToTop();

  const handleSelectId = useCallback(
    (id?: string | null): void => {
      const path = id ? `/myaccount/fines/child/${id}` : `/myaccount/fines`;
      navigate(path);
    },
    [navigate],
  );

  return (
    <Box component="div" ref={scrollCallbackRef}>
      {hasChildrenAndCanViewDependentFinesActivity && (
        <Box component="div" sx={{ p: 1 }}>
          <AccountGuardianSelector selectedId={id} onSelect={handleSelectId} />
        </Box>
      )}
      <Outlet context={{ scrollToTop }} />
    </Box>
  );
};
